import { gql } from "~/__generated__"

export const CREATE_CHECKOUT_SESSION = gql(`
  mutation CreateCheckoutSession($stripePriceId: String!) {
    checkoutSessionCreate(input: { stripePriceId: $stripePriceId }) {
      sessionUrl
    }
  }
`)

export const ROSTER_PLAN_ACTIVATE = gql(`
  mutation RosterPlanActivate {
    rosterPlanActivate(input: {}) {
      user {
        ...CurrentUser
      }
    }
  }
`)
